<template>
  <div class="score">
    <div class="title">
      信用评分<span
        >CR评级是对企业进行信用评分和预授信，可帮助金融机构更快、更精确的为您提供金融服务。</span
      >
    </div>
    <div class="firm">
      <div class="firmTitle">企业信息</div>
      <div class="firmBox">
        <el-form
          :model="form"
          ref="form"
          class="demo-form-inline"
          label-width="120px"
          :rules="rules"
        >
          <el-form-item label="申请企业" prop="qymc">
            <el-input
              v-model="form.qymc"
              style="width: 260px"
              placeholder="请输入内容"
              readonly
            ></el-input> </el-form-item
          ><el-form-item label="成立日期" prop="clsj">
            <el-date-picker
              v-model="form.clsj"
              style="width: 260px"
              type="date"
              value-format="timestamp"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="营业收入" prop="yysr">
            <el-input
              v-model="form.yysr"
              style="width: 260px"
              placeholder="请输入内容"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="资产总额" prop="zcze">
            <el-input
              v-model="form.zcze"
              style="width: 260px"
              placeholder="请输入内容"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="实收股东" prop="ssgd">
            <el-input
              v-model="form.ssgd"
              style="width: 260px"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工数量" prop="ygsl">
            <el-input
              v-model="form.ygsl"
              style="width: 260px"
              placeholder="请输入内容"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业状态" prop="qyzt">
            <el-input
              v-model="form.qyzt"
              style="width: 260px"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="行业类别" prop="hylb">
            <el-input
              v-model="form.hylb"
              style="width: 260px"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="stockholder">
      <div class="firmTitle">股东信息</div>
      <div class="stockholderBox">
        <el-form
          :model="form"
          ref="forms"
          class="demo-form-inline"
          label-width="220px"
          :rules="rules"
        >
          <el-form-item label="控股股东的企业类型" prop="kgqylx">
            <el-input
              v-model="form.kgqylx"
              style="width: 260px"
              placeholder="请输入内容"
            ></el-input> </el-form-item
          ><el-form-item label="控股股东的注册资本" prop="kggdzczb">
            <el-input
              v-model="form.kggdzczb"
              style="width: 260px"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="finance">
      <div class="title">
        财务信息
        <span>最近3年的企业财务信息， 单位:万元</span>
      </div>
      <div class="financeBox">
        <div class="financeTitle">需要填写近两年及本年当期财务报表</div>
        <div class="financeTable">
          <ul>
            <li>
              <span>年度</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.year"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*股东权益台计</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.gdqyhj"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*负债合计</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.fzhj"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*流动负债台计</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.ldfzhj"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span style="color: red">*净利润</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.jlr"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*营业利润</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.yylr"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*营业收入</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.yysr"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*营业成本</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.yycb"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span style="color: red">*利润总额</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.lrze"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*资产总额</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.zcze"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*存货</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.ch"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*应收账款</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.yszg"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*流动资产合计</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.ldzczh"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*实收资本</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.sszb"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
            <li>
              <span>*资本公积</span>
              <span v-for="(item, index) in form.financeReports" :key="index">
                <el-input
                  v-model="item.zbgj"
                  style="width: 100%"
                  placeholder="请输入内容"
                  type="number"
                ></el-input
              ></span>
            </li>
          </ul>
        </div>
        <div class="boxBottom">
          <span class="update"> 上报财务报表 </span>
          <div class="custom-upload" style="margin-top: 20px">
            <el-upload
              class="avatar-uploader"
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="uploadedFiles"
              accept=".jpg, .jpeg, .png,.pdf"
            >
              <span slot="tip" class="el-upload__tip">
                需要2021年、2022年及2023年当期数据均需提供财务报表，文件格式支持图片、PDF
              </span>
              <div class="buttonList">
                <span class="select-img-tip button">上传文件</span>
              </div>
            </el-upload>
            <ul class="fileList" v-if="form.fileList.length > 0">
              <li v-for="(item, index) in form.fileList" :key="index">
                <a
                  :href="baseUrl + item.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{
                    item.title
                      ? item.title
                      : item.url.split("/")[item.url.split("/").length - 1]
                  }}</a
                >
                <i
                  class="el-icon-close"
                  style="float: right; font-size: 20px; cursor: pointer"
                  @click="deleFile(item, index)"
                ></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="promise">
          <el-checkbox v-model="checked"
            >阅读并承诺</el-checkbox
          ><b @click.stop="showDialog = true" style="color: #1366ec"
              >《信用承诺书》</b
            >
        </div>
        <div class="buttonList">
          <span class="button" @click="sumbit">提交，开始评价</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="信用承诺书"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="800px"
      top="15vh"
    >
      <div class="dialogTitle">
        <p>
          为共同构建社会诚信体系，维护良好的市场经济环境，营造诚实守信的信用环境，共同推动社会信用体系建设的健康发展，树立企业诚信守法经营形象。
          郑重做出以下承诺：
        </p>
        <p>
          一、组织或本人所提供的所有资料或信息均合法、真实、准确和有效，并对所提供的资料真实性负责。
        </p>
        <p>二、自觉接受政府、行业组织、社会公众、新闻舆论的监督。</p>
        <p>
          三、严格依照国家有关法律、法规和规章，依法取得主体资格和经营资格后，依法开展生产经营活动，照章纳税；积极履行社会责任。
        </p>
        <p>
          四、严格遵守国家法律、法规、规章和政策规定，按照要求规范操作、规范管理，强化自律，诚实守信，不造假、不失信。
        </p>
        <p>
          五、本单位企业法人代表、董事、监事、高管自愿维护良好的个人信用记录。
        </p>
        <p>六、严格遵守报告制度，及时如实地报告有关情况，不瞒报、不虚报。</p>
        <p>七、本《信用承诺书》同意向社会公开。</p>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center;display: block;">
        <el-button
          type="primary"
          @click="acceptDialog"
          style="background: #1366ec; border: 1px solid #1366ec"
          >接受承诺</el-button
        >
        <el-button @click="showDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getInformation, addInformation, getEnterprise } from "./viewApi";
import { uploadFiles } from "@/api/index";
import { validateForm } from "@/utils";
export default {
  data() {
    return {
      showDialog: false,
      baseUrl: process.env.VUE_APP_IMG_API,
      fileDialog: {
        title: "选择文件",
        visible: false,
      },
      checked: false,
      form: {
        qymc: "",
        delIds: [],
        dm: "",
        kgqylxdm: "1",
        hylbdm: "1",
        financeReports: [
          {
            year: null,
            zcze: null,
            gdqyhj: null,
            yysr: null,
            fzhj: null,
            yylr: null,
            lrze: null,
            ldfzhj: null,
            yycb: null,
            ch: null,
            yszg: null,
            ldzczh: null,
            sszb: null,
            zbgj: null,
            jlr: null,
          },
          {
            year: null,
            zcze: null,
            gdqyhj: null,
            yysr: null,
            fzhj: null,
            yylr: null,
            lrze: null,
            ldfzhj: null,
            yycb: null,
            ch: null,
            yszg: null,
            ldzczh: null,
            sszb: null,
            zbgj: null,
            jlr: null,
          },
          {
            year: null,
            zcze: null,
            gdqyhj: null,
            yysr: null,
            fzhj: null,
            yylr: null,
            lrze: null,
            ldfzhj: null,
            yycb: null,
            ch: null,
            yszg: null,
            ldzczh: null,
            sszb: null,
            zbgj: null,
            jlr: null,
          },
        ],
        fileList: [],
      },
      delIds: [],
      rules: {
        zcze: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        clsj: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        yysr: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        ssgd: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        ygsl: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        qyzt: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        hylb: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        hylbdm: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        kgqylx: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        kggdzczb: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  created() {
    this.getEnter();
    this.getData();
  },
  methods: {
    acceptDialog() {
      this.checked = true;
      this.showDialog = false;
      
    },
    closeDialog() {
      this.checked = false;
      this.showDialog = false;
    },
    async getEnter() {
      let res = await getEnterprise();
      this.form.qymc = res.data.qymc;
      this.form.dm = res.data.dm;
    },
    deleFile(item, index) {
      let delIds = this.form.delIds ? this.form.delIds : [];
      if (item.id) {
        delIds.push(item.id);
        this.form.delIds = delIds;
      }
      let fileList = this.form.fileList;
      fileList.splice(index, 1);
      this.form.fileList = fileList;
    },
    closeFileDialog() {
      this.fileDialog.visible = false;
    },
    uploadedFiles(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      uploadFiles(formData).then((res) => {
        if (res.data) {
          this.form.fileList.push({
            title: res.data.fileName,
            url: res.data.url,
          });
        }
      });
    },
    sumbit() {
      let message = "";
      if (!this.checked) {
        message = "请勾选承诺书";
        this.$baseMessage(message, "error");
        return;
      }
      if (!validateForm(this.$refs["form"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      if (!validateForm(this.$refs["forms"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      for (var i = 0; i < this.form.financeReports.length; i++) {
        let item = this.form.financeReports[i];
        for (const key in item) {
          console.log(item[key], "item[key] ");
          if (item[key] == null || item[key] == "" || item[key].length == 0) {
            message = "表单信息缺失。";
            this.$baseMessage(message, "error");
            return;
          }
        }
      }
      addInformation(this.form).then((res) => {
        if (res.code == 1000) {
          this.$baseMessage("提交成功", "success");
          this.getData();
        }
      });
    },
    async getData() {
      let res = await getInformation();
      if (res.data) {
        this.form = res.data;
        var date = new Date();
        let y = date.getFullYear();

        if (res.data.financeReports.length < 3) {
          let newObj = {
            year: null,
            zcze: null,
            gdqyhj: null,
            yysr: null,
            fzhj: null,
            yylr: null,
            lrze: null,
            ldfzhj: null,
            yycb: null,
            ch: null,
            yszg: null,
            ldzczh: null,
            sszb: null,
            zbgj: null,
            jlr: null,
          };
          let arr = [newObj, newObj, newObj];
          for (var i = 0; i < res.data.financeReports.length; i++) {
            arr[res.data.financeReports[i].year - y + 2] =
              res.data.financeReports[i];
          }
          this.form.financeReports = arr;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.score {
  background: white;
  border-radius: 16px;
  padding: 10px;
  .title {
    border-bottom: 1px solid #ccc;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
    span {
      font-weight: 100;
      margin-left: 20px;
      font-size: 14px;
    }
  }
  .firm,
  .stockholder {
    .firmTitle {
      border-bottom: 1px solid #ccc;
      line-height: 40px;
      padding: 0 10px;
      margin-bottom: 20px;
    }
  }
  .financeBox {
    .financeTitle {
      line-height: 40px;
    }
    .financeTable {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      li {
        span {
          display: inline-block;
          width: 25%;
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
          line-height: 40px;
          height: 40px;
          vertical-align: top;
          font-size: 0;
          &:nth-child(1) {
            padding: 0 10px;
            font-size: 16px;
          }
        }
      }
    }
    .boxBottom {
      margin: 20px 0;
      .update {
        font-weight: bold;
      }
    }
    .promise {
      text-align: center;
      margin-top: 40px;
      .el-checkbox,
      ::v-deep .el-checkbox__label {
        font-size: 18px;
        font-weight: bold;
      }
      b{
         font-size: 18px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .buttonList {
      display: block;
      text-align: center;
      margin-top: 50px;
    }
    .button {
      display: inline-block;
      margin-bottom: 10px;
      border: 1px solid #1366ec;
      padding: 10px 25px;
      border-radius: 5px;
      color: #fff;
      background: #1366ec;
      cursor: pointer;
    }
  }
  .fileList {
    li {
      width: 100%;
      line-height: 40px;
    }
  }
}
.dialogTitle {
  p {
    font-size: 16px;
    line-height: 40px;
  }
}
</style>